import api from 'plugin/api';

/**
 *  @description 시료정보 관리 목록 API
 */

async function standardInfoList(params) {
  const url = '/sfsh/inspection/standard';

  const response = await api.get(url, { params });
  return response;
}

/**
 *  @description 시료정보 관리 등록 API
 */

async function standardInfoCreate(requestBody) {
  const url = '/sfsh/inspection/standard';

  const response = await api.post(url, requestBody);
  return response;
}

/**
 *  @description 시료정보 관리 상세 API
 */
async function standardInfoDetail(seq) {
  const url = `/sfsh/inspection/standard/${seq}`;

  const response = await api.get(url);
  return response;
}

/**
 *  @description 시료정보 관리 수정 API
 */
async function standardInfoUpdate(seq, requestBody) {
  const url = `/sfsh/inspection/standard/${seq}`;

  const response = await api.put(url, requestBody);
  return response;
}

async function inrdntGrpoupList(params) {
  const url = '/sfsh/inspection/irdnt-grp/with-detail';

  const response = await api.get(url, { params });
  return response;
}

export {
  standardInfoList,
  standardInfoCreate,
  standardInfoDetail,
  standardInfoUpdate,
  inrdntGrpoupList
};
